<script setup lang="ts">
    defineProps<{ tickCount: number }>();
    const model = defineModel<number>();
</script>


<template>
    <v-slider
        v-model="model"
        :max="tickCount - 1"
        step=1
        color="primary"
        show-ticks="always"
        tick-size=8
        track-size=1
        track-color="grey-light-1"
        thumb-size=12
        hide-details />
</template>

<!--suppress CssUnusedSymbol -->
<style scoped lang="scss">
    :deep(.v-slider-track__tick) {
        background-color: rgb(var(--v-theme-grey-light-1));
        opacity: 1;
    }

    :deep(.v-slider-thumb__surface),
    :deep(.v-slider-track__tick--filled),
    :deep(.v-slider-track__fill) {
        background-color: rgb(var(--v-theme-primary));
        opacity: 1;
    }

    :deep(.v-slider-track__background) {
        background-color: rgb(var(--v-theme-grey-light-1));
        opacity: 1;
        height: 3px !important;
    }

    :deep(.v-slider-track__tick) {
        border-radius: 4px;
    }

    :deep(.v-slider-track__tick--first) {
        margin-inline-start: 0 !important;
    }

    :deep(.v-slider-track__tick--last) {
        margin-inline-start: 100% !important;
    }
</style>
